import React, { Fragment } from 'react'
import { Loader } from '@web/walter-ui-kit'

import styles from './style.module.css'

export function Preloader() {
    return (
        <div className={styles.tab}>
            {Array.from({ length: 3 }).map((_, index) => (
                <Fragment key={index}>
                    <Loader width={70} height={20} />
                    <div className={styles.input}>
                        <Loader borderRadius="m" width="100%" height={50} />
                    </div>
                </Fragment>
            ))}

            <div className={styles.info}>
                <Loader width={80} height={18} />
                <Loader width="80%" height={20} />
                <Loader width={200} height={18} />
            </div>
            <div className={styles.contactSupport}>
                <Loader width={120} height={20} />
                <Loader width="80%%" height={10} />
                <Loader width={200} height={10} />
                <div className={styles.button}>
                    <Loader width={160} height={36} borderRadius="s" />
                </div>
            </div>
        </div>
    )
}
